import { useEffect, useState } from 'react'
import { styled } from '@/src/stitches.config'
import {
    MoreInfoText,
    ShowMoreInfo,
} from '@/src/modules/pg-plus/PGPlusStyledComponents'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { slideDown } from '@/src/common/animations'

const DescriptionWrapper = styled('div', {
    mt: 0,
    lh: '1.5rem',
    '& li': {
        mb: 5,
    },
    '& h3': {
        fontWeight: 'bold',
        fontSize: '1.5rem',
        color: '$dark',
    },
    '& h4': {
        fontWeight: 'bold',
        fontSize: '1.05rem',
        lineHeight: '1.75rem',
        mb: 30,
        color: '$dark',
    },
    '& a': {
        color: '$primary',
        textDecoration: 'underline',
    },
    '& p': {
        fontWeight: 'normal',
        fontSize: '$3',
        mt: 0,
        mb: 15,
    },
})

interface IBrandDescriptionProps {
    brandName: string
    description: any
    startOpen?: boolean
}

const BrandDescription = ({
    brandName,
    description,
    startOpen = false,
}: IBrandDescriptionProps) => {
    const [showBrandInfo, setShowBrandInfo] = useState<boolean>(false)

    useEffect(() => {
        setShowBrandInfo(startOpen)
    }, [startOpen])

    return (
        <>
            <ShowMoreInfo onClick={() => setShowBrandInfo(!showBrandInfo)}>
                <MoreInfoText>About {brandName}</MoreInfoText>
                <FontAwesomeIcon
                    icon={showBrandInfo ? faAngleUp : faAngleDown}
                />
            </ShowMoreInfo>
            {showBrandInfo && (
                <div
                    style={{
                        animation: showBrandInfo
                            ? `${slideDown} 0.5s ease-in-out`
                            : 'none',
                    }}
                >
                    {description && (
                        <DescriptionWrapper>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: description,
                                }}
                            />
                        </DescriptionWrapper>
                    )}
                    <DescriptionWrapper>
                        <h4>Does my {brandName} gift card expire?</h4>
                        <p>
                            Any gift sent on BuyGiftCards.com, including{' '}
                            {brandName} gifts, will never expire. When it comes
                            to using your {brandName} gift or gift card, your
                            gift recipient has the safety and security of
                            knowing they can use it immediately, or wait until
                            the perfect time in the future for something
                            they&apos;ll love without worry.
                        </p>
                    </DescriptionWrapper>
                </div>
            )}
        </>
    )
}

export default BrandDescription
